'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavItem", {
    enumerable: true,
    get: function() {
        return NavItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNavItem = require("./useNavItem");
const _renderNavItem = require("./renderNavItem");
const _useNavItemStylesstyles = require("./useNavItemStyles.styles");
const NavItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavItem.useNavItem_unstable)(props, ref);
    (0, _useNavItemStylesstyles.useNavItemStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useNavItemStyles_unstable')(state);
    return (0, _renderNavItem.renderNavItem_unstable)(state);
});
NavItem.displayName = 'NavItem';
